import { parseBrandBackground } from '@vedalib/editor/lib/brand'
import type { ObjectFitEnum } from '@vedalib/editor/lib/files'
import type React from 'react'
import { useMemo } from 'react'

import { getObjectFitDivMap } from 'components/Editor/EditorElements/utils/getObjectFitDivMap'
import { useBrandTheme } from 'services/Branding/hooks'
import { getOriginalImageById } from 'utils/files'

export const useGetBgImageStyles = (overlay?: string | null) => {
  const theme = useBrandTheme()

  const imgStyles = useMemo(() => {
    const background = parseBrandBackground(theme?.background)
    const backgroundImg = getOriginalImageById(background?.image)

    return {
      backgroundColor: background.color,
      backgroundImage: `url(${backgroundImg?.path})`,
      backgroundSize: getObjectFitDivMap(background?.objectFit as ObjectFitEnum) || 'auto',
      backgroundPosition: background?.position || 'center',
      backgroundRepeat: background?.repeat || 'no-repeat',
      backgroundAttachment: background?.attachment || 'fixed',
      '--overlay': overlay ?? background.overlay,
    } as React.CSSProperties
  }, [theme?.background, overlay])
  return imgStyles
}
